const ImageIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M15.111 7.852h.012"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="m2.666 16.148 5.185-5.185c.963-.926 2.149-.926 3.111 0l5.186 5.185m-2.074-2.074 1.037-1.037c.963-.926 2.149-.926 3.111 0l3.111 3.111"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M2.666 7.333a4.667 4.667 0 0 1 4.667-4.667h9.333a4.667 4.667 0 0 1 4.667 4.667v9.333a4.667 4.667 0 0 1-4.667 4.667H7.333a4.667 4.667 0 0 1-4.667-4.667V7.333Z"
      />
    </svg>
  );
};

export default ImageIcon;
